module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Gb-Ha-Ia-Gc(1).a3201eac.png";